import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import preloaded from '../src/preloaded.js';
import CalendarEventDisplay from '../src/calendars/CalendarEventDisplay.jsx';
import { store } from '../src/calendars/redux/';


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <CalendarEventDisplay
        singleTeamView={preloaded.single_team_view}
        initialEvents={preloaded.initial_events}
        initialMonth={preloaded.initial_month}
        initialOccurrencesByEventId={preloaded.occurrences_by_event_id}
        calendarBaseUrl={preloaded.calendar_base_url}
        showPractices={preloaded.show_practices}
        pageable={!preloaded.complete_schedule || false}
        today={preloaded.today}
        scheduleTimezone={preloaded.schedule_timezone}
      />
    </Provider>
  </React.StrictMode>,
  document.getElementById("app")
);
